// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./MenuGroupTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuGroupTitle-module__Container__YfZTI {
    display: flex;
    gap: var(--ds-s);
    align-items: center;
    padding: var(--ds-3x) var(--ds-s);
}

.MenuGroupTitle-module__Icon__X0nlP {
    color: var(--ds-menu-group-title-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `MenuGroupTitle-module__Container__YfZTI`,
	"Icon": `MenuGroupTitle-module__Icon__X0nlP`
};
export default ___CSS_LOADER_EXPORT___;
